import { useForm, Form, Input, Create, InputNumber, Select, useSelect } from "@pankod/refine-antd";
import { useNavigation } from "@pankod/refine-core";
import React from "react";

export const CategoryCreate: React.FC = () => {
  const { push } = useNavigation();
  const { formProps, saveButtonProps } = useForm({
    resource: "category-forum",
    redirect: false,
    onMutationSuccess: () => {
      push("/admin/chat-center/category");
    },
  });
  const { selectProps } = useSelect({
    resource: "company",
    optionLabel: "name",
    optionValue: "id",
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          className="w-100"
          label={"Name"}
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"Company"}
          name={["company", "id"]}
          rules={[
            {
              required: true,
            },
          ]}
          className="w-full"
        >
          <Select {...selectProps} placeholder="Company" />
        </Form.Item>
        <Form.Item className="w-100" label={"Order"} name="order">
          <InputNumber />
        </Form.Item>
      </Form>
    </Create>
  );
};
